import { render, staticRenderFns } from "./DeleteAlertRSModal.vue?vue&type=template&id=48defc74&scoped=true&"
import script from "./DeleteAlertRSModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAlertRSModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAlertRSModal.vue?vue&type=style&index=0&id=48defc74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48defc74",
  null
  
)

export default component.exports